import React, { createContext, useContext, useState, useLayoutEffect, useEffect } from 'react'
import { StreamrTvLaunchDate } from '../components/Top/Hero'

const STORAGE_KEY = 'streamrtv-banner-dismissed'

const StreamrTvBannerContext = createContext()

export const StreamrTvBannerProvider = ({ children }) => {
    const [isVisible, setIsVisible] = useState(false)
    const [shouldRender, setShouldRender] = useState(false)
    const [bannerHeight, setBannerHeight] = useState(0)
    const [isBannerEnabled, setIsBannerEnabled] = useState(
        new Date() >= new Date(StreamrTvLaunchDate),
    )

    // Update isBannerEnabled every 250ms until we're past the launch date
    useEffect(() => {
        if (isBannerEnabled) {
            return
        }

        const checkTime = () => {
            const dateNow = Math.ceil(Date.now() / 1000) * 1000 // Round to the next second
            const diff = (new Date(StreamrTvLaunchDate).getTime() - dateNow) / 1000

            if (diff <= 0) {
                setIsBannerEnabled(true)
            }
        }

        checkTime()
        const interval = setInterval(checkTime, 250)

        return () => clearInterval(interval)
    }, [isBannerEnabled])

    // Initialize banner state synchronously to prevent layout shifts
    useLayoutEffect(() => {
        const isBannerDismissed = localStorage.getItem(STORAGE_KEY) === 'true'
        const initialVisible = !isBannerDismissed

        if (isBannerEnabled) {
            setIsVisible(initialVisible)
            setShouldRender(initialVisible)
            setBannerHeight(initialVisible ? 40 : 0)
        } else {
            setIsVisible(false)
            setShouldRender(false)
            setBannerHeight(0)
        }
    }, [isBannerEnabled])

    const closeBanner = () => {
        setIsVisible(false)
        setBannerHeight(0)
        localStorage.setItem(STORAGE_KEY, 'true')

        // Remove from DOM after animation completes
        setTimeout(() => {
            setShouldRender(false)
        }, 300)
    }

    const value = {
        isVisible,
        shouldRender,
        closeBanner,
        bannerHeight,
    }

    return (
        <StreamrTvBannerContext.Provider value={value}>{children}</StreamrTvBannerContext.Provider>
    )
}

export const useStreamrTvBanner = () => {
    const context = useContext(StreamrTvBannerContext)
    if (!context) {
        throw new Error('useStreamrTvBanner must be used within a StreamrTvBannerProvider')
    }
    return context
}
